import React from "react";
import {Form, FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form";
import {ButtonGroup, ButtonGroupItem} from "@/components/CustomRadioGroup";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "@/components/ui/select";

interface StepCondizioniVeicoloProps {
    formCondizioniVeicolo: any;
}

const StepCondizioniVeicolo: React.FC<StepCondizioniVeicoloProps> = ({formCondizioniVeicolo}) => (
    <Form {...formCondizioniVeicolo}>
        <form id="formCondizioniVeicolo" onSubmit={formCondizioniVeicolo.handleSubmit(() => {})}
              className="grid grid-cols-1 gap-4">

            {/* L'auto ha mai subito incidenti? */}
            <FormField control={formCondizioniVeicolo.control} name="reqIncidenti"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>L'auto ha mai subito incidenti?</FormLabel>
                               <FormControl>
                                   <ButtonGroup ref={field.ref} value={field.value}
                                                onValueChange={(value) => field.onChange(value)}>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Si" label="Si"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="No" label="No"/>
                                   </ButtonGroup>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* Stato degli interni */}
            <FormField control={formCondizioniVeicolo.control} name="reqInterni"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Qual è lo stato degli interni dell'auto?</FormLabel>
                               <FormControl>
                                   <ButtonGroup columns={3} ref={field.ref} value={field.value}
                                                onValueChange={(value) => field.onChange(value)}>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="In buone condizioni"
                                                        label="In buone condizioni"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Utilizzo moderato"
                                                        label="Utilizzo moderato"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Utilizzo intenso"
                                                        label="Utilizzo intenso"/>
                                   </ButtonGroup>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* Stato degli esterni */}
            <FormField control={formCondizioniVeicolo.control} name="reqEsterni"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Qual è lo stato degli esterni dell'auto?</FormLabel>
                               <FormControl>
                                   <ButtonGroup columns={3} ref={field.ref} value={field.value}
                                                onValueChange={(value) => field.onChange(value)}>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="In buone condizioni"
                                                        label="In buone condizioni"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Utilizzo moderato"
                                                        label="Utilizzo moderato"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Utilizzo intenso"
                                                        label="Utilizzo intenso"/>
                                   </ButtonGroup>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* Spie luminose */}
            <FormField control={formCondizioniVeicolo.control} name="reqSpie"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Ci sono spie luminose accese permanenti sul cruscotto della
                                   tua auto?</FormLabel>
                               <FormControl>
                                   <ButtonGroup ref={field.ref} value={field.value}
                                                onValueChange={(value) => field.onChange(value)}>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Si" label="Si"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="No" label="No"/>
                                   </ButtonGroup>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* Danni e segni di usura */}
            <FormField control={formCondizioniVeicolo.control} name="reqUsura"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Danni e segni di usura</FormLabel>
                               <FormControl>
                                   <ButtonGroup ref={field.ref} value={field.value}
                                                onValueChange={(value) => field.onChange(value)}>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Si" label="Si"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="No" label="No"/>
                                   </ButtonGroup>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* Come si presenta il motore? */}
            <FormField control={formCondizioniVeicolo.control} name="reqMotore"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Come si presenta il motore?</FormLabel>
                               <FormControl>
                                   <Select {...field} onValueChange={(value) => field.onChange(value)}
                                           value={field.value}>
                                       <SelectTrigger className="">
                                           <SelectValue placeholder="Seleziona lo stato del motore"/>
                                       </SelectTrigger>
                                       <SelectContent>
                                           <SelectItem value="Motore in buone condizioni">Motore in
                                               buone condizioni</SelectItem>
                                           <SelectItem value="Motore da riparare">Motore da
                                               riparare</SelectItem>
                                       </SelectContent>
                                   </Select>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* Come si presenta il cambio? */}
            <FormField control={formCondizioniVeicolo.control} name="reqCambio"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Come si presenta il cambio?</FormLabel>
                               <FormControl>
                                   <Select {...field} onValueChange={(value) => field.onChange(value)}
                                           value={field.value}>
                                       <SelectTrigger className="">
                                           <SelectValue placeholder="Seleziona lo stato del cambio"/>
                                       </SelectTrigger>
                                       <SelectContent>
                                           <SelectItem value="Cambio in buone condizioni">Cambio in
                                               buone condizioni</SelectItem>
                                           <SelectItem value="Cambio da riparare">Cambio da
                                               riparare</SelectItem>
                                       </SelectContent>
                                   </Select>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* Come si presenta la frizione? */}
            <FormField control={formCondizioniVeicolo.control} name="reqFrizione"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Come si presenta la frizione?</FormLabel>
                               <FormControl>
                                   <Select {...field} onValueChange={(value) => field.onChange(value)}
                                           value={field.value}>
                                       <SelectTrigger className="">
                                           <SelectValue
                                               placeholder="Seleziona lo stato della frizione"/>
                                       </SelectTrigger>
                                       <SelectContent>
                                           <SelectItem value="Frizione in buone condizioni">Frizione in
                                               buone condizioni</SelectItem>
                                           <SelectItem value="Frizione da riparare">Frizione da
                                               riparare</SelectItem>
                                       </SelectContent>
                                   </Select>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* Condizionatore */}
            <FormField control={formCondizioniVeicolo.control} name="reqCondizionatore"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Il sistema di climatizzazione è in perfette
                                   condizioni?</FormLabel>
                               <FormControl>
                                   <ButtonGroup columns={3} ref={field.ref} value={field.value}
                                                onValueChange={(value) => field.onChange(value)}>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Si" label="Si"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="No" label="No"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Inesistente" label="Inesistente"/>
                                   </ButtonGroup>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />
        </form>
    </Form>
);

export default StepCondizioniVeicolo;
